var React = require('react');

function StatusCancelled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M16.9 8.53C17.6 9.5 18 10.7 18 12c0 3.3-2.7 6-6 6-1.3 0-2.5-.4-3.48-1.1l8.37-8.37zM15.47 7.1c-1-.7-2.2-1.1-3.48-1.1-3.3 0-6 2.7-6 6 0 1.3.4 2.5 1.1 3.47l8.4-8.37zM12 4c4.42 0 8 3.6 8 8 0 4.42-3.6 8-8 8-4.42 0-8-3.6-8-8 0-4.42 3.6-8 8-8z"}));
}

StatusCancelled.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StatusCancelled;

StatusCancelled.default = StatusCancelled;
